import React from "react";
import ButtonComponent from "../generic/ButtonComponent";
import { ADABOT_BINDER_PORTAL } from "../../constants/featureFlags";
import { useOpenFreshworksTicket } from "../../hooks/freshworksHooks";
import { useFeatureFlag } from "../../hooks/globalSettingsHooks";
import { useStoreDetails } from "../../hooks/storeHooks";
import {
  openForethoughtWidget,
  updateForethoughtContext,
} from "../services/ForethoughtChatbot";

interface PreviousImportsSupportButtonProps {
  id: string;
  fileType: string;
}

function PreviousImportsSupportButton(
  props: PreviousImportsSupportButtonProps
) {
  const { id, fileType } = props;
  const adaBotBinderPortal = useFeatureFlag(ADABOT_BINDER_PORTAL);
  const { customerId, customerName, customerSiteUrl, customerEmail } =
    useStoreDetails();
  const openFreshworksTicket = useOpenFreshworksTicket();

  const reportIssueToFreshworks = () =>
    openFreshworksTicket(
      `Product import: CSV #${id}`,
      "Question",
      "Issue reported with uploaded CSV file",
      `CSV file: id ${id}, type: ${fileType}`
    );
  const reportIssueToAdaBot = () => {
    updateForethoughtContext({
      store_id: customerId,
      store_name: customerName,
      store_url: customerSiteUrl,
      store_email: customerEmail,
      csv_import_id: id,
      csv_import_type: fileType,
    });
    openForethoughtWidget();
  };

  const reportIssue = adaBotBinderPortal
    ? reportIssueToAdaBot
    : reportIssueToFreshworks;

  return (
    <ButtonComponent icon="far fa-flag-alt" onClick={reportIssue}>
      Report issue
    </ButtonComponent>
  );
}

export default PreviousImportsSupportButton;
